import "./sentry";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Mock user initialization disabled - using OneID authentication instead
// import { MOCK_USER } from "@/modules/base/constants/mockUser";

import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";

import "./content-protection";

// Initialize mock user data in localStorage
// Disabled - using OneID authentication instead
// const initializeMockUser = () => {
//   const STORAGE_KEYS = {
//     ACCESS_TOKEN: "access_token",
//     REFRESH_TOKEN: "refresh_token",
//     USER: "user",
//   };

//   // Only set if not already present (to allow manual override)
//   if (!localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)) {
//     localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, MOCK_USER.access);
//     localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, MOCK_USER.refresh);
//     localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(MOCK_USER.user));
//   }
// };

// Initialize before rendering
// initializeMockUser();

// macOS-style scrollbar: Add 'scrolling' class to body when scrolling
let scrollTimeout: ReturnType<typeof setTimeout>;
document.addEventListener(
  "scroll",
  () => {
    document.body.classList.add("scrolling");
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      document.body.classList.remove("scrolling");
    }, 500);
  },
  true,
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
